function getQuarter(duration, currentTime) {
    const FirstQuarter  = Math.trunc(duration / 4) ;
    const secondQuarter = FirstQuarter * 2;
    const ThirdQuarter = FirstQuarter * 3;
    const FourthQuater = FirstQuarter * 4;
    const currentTimeTrunced= Math.trunc(currentTime);
    if (currentTimeTrunced === FirstQuarter) {
        return 1
    }
    if (currentTimeTrunced === secondQuarter) {
        return 2
    }
    if (currentTimeTrunced === ThirdQuarter) {
        return 3
    }
    if (currentTimeTrunced === FourthQuater) {
        return 4
    }
    return 0
}
export function secondsToDuration(secs) {
    const sec_num = parseInt(secs, 10);
    const hours = Math.floor(sec_num / 3600) % 24;
    const minutes = Math.floor(sec_num / 60) % 60;
    const seconds = sec_num % 60;

    return [hours, minutes, seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v, i) => v !== "0" || i > 0)
        .join(":")
}
export function durationToSeconds(duration) {
    if(duration){
        let [hours, minutes, seconds] = duration.split(":").map(Number);
        let totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
        return totalSeconds;
    }else{
        return 0;
    }

}
export function getTheExactQuarter(duration, currentTime) {
        return getQuarter(duration, currentTime);
}